import { hot } from 'react-hot-loader/root';
import React from 'react';
import { Provider } from 'react-redux';
import store from './babel/store';
import Routes from 'App/pages/routes';
import AngularApp from './AngularApp';
import Modals from './components/Modals';
import AppOnboarding from 'App/pages/AppOnboarding'; // Rename if not intended to replace current onboarding
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import SystemNotifications from 'Components/SystemNotifications/SystemNotifications';
import { Route, HashRouter as Router } from 'react-router-dom';
import Login from 'App/pages/Login';
import MCPLogin from 'App/pages/MCPLogin/MCPLogin';
import { doStaticSetup } from './helpers/appHelper';
import Session, { onlyRenderWhenAuthenticated } from './Session';
import NavbarComponent from './navbar/Navbar';
import AppSidebarComponent from 'App/components/AppSidebar';
doStaticSetup();

const Navbar = onlyRenderWhenAuthenticated(NavbarComponent);
const AppSidebar = onlyRenderWhenAuthenticated(AppSidebarComponent);

// Generate a deterministic color from the port number for worktree environments
const getWorktreeBorderColor = () => {
	const port = process.env.WORKTREE_PORT;
	if (!port) return null;
	const colors = ['#e74c3c', '#2ecc71', '#3498db', '#9b59b6', '#e67e22', '#1abc9c', '#f39c12', '#e91e63'];
	let hash = 0;
	for (let i = 0; i < port.length; i++) {
		hash = port.charCodeAt(i) + ((hash << 5) - hash);
	}
	return colors[Math.abs(hash) % colors.length];
};
const worktreeBorderColor = getWorktreeBorderColor();

const App = () => {
	const content = (
		<Router>
			<Provider store={store}>
				{/* Make Session component handle init and dispatch actions */}
				<Session>
					<Route path="/login" component={Login} />
					<Route path="/mcp-login" component={MCPLogin} />
					<AngularApp>
						<DndProvider backend={HTML5Backend}>
							<div>
								<Navbar />
								<AppSidebar />
								<Routes />
								<Modals />
								<AppOnboarding />
							</div>
							<SystemNotifications />
						</DndProvider>
					</AngularApp>
				</Session>
			</Provider>
		</Router>
	);

	if (!worktreeBorderColor) return content;

	return (
		<>
			{content}
			<div style={{
				position: 'fixed',
				inset: 0,
				border: `4px solid ${worktreeBorderColor}`,
				pointerEvents: 'none',
				zIndex: 99999
			}} />
		</>
	);
};

export default hot(App);
